module.exports = __webpack_public_path__ + "static/media/notiSound.a2050abb.mp3";